<template>
  <div class="program-grup">
    <cs-form label-width="90px" class="header-search-box padding-t-20" ref="groupForm"  form-width="100%"
      :form="formValue"
      :formData="searchData"
      :form-cols="searchFormCol"
      :rules="rules"
      @form-change="formChange">
      <template slot="score">
        <el-rate v-model='formValue.score' show-score score-template="{value}星" text-color="#606266" style="margin-top:6px"></el-rate>
      </template>
      <template slot="dsc">
        <el-input type="textarea" v-model='formValue.dsc' maxlength="80" show-word-limit style="width:1000px"></el-input>
      </template>
      <template slot="keywords">
          <el-input v-model='formValue.keywords' readonly></el-input>
          <div class="margin-t-box">
            <el-tag :key="tag"  v-for="tag in keywords_tags" closable :disable-transitions="false" @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm">
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
          </div>
      </template>
      <template slot="sndCategory">
          <el-select v-model="sndOptions" multiple filterable allow-create placeholder="请选择"  @change = "sndChange">
            <el-option
              v-for="item in sndCategory"
              :key="item.label"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </template>
      <template slot="poster">
        <el-upload
          class="upload-demo-poster"
          ref="upload"
          :action="postVideoUrl"
          name="videoImg"
          :on-preview="handlePreview"
          :http-request="upload"
          :on-success="uploadSuccess"
          :on-remove="uploadRemove"
          :on-exceed="handleExceed"
          :limit="1"
          :file-list="posterList"
          list-type="picture-card">
          <!-- <el-button size="small" type="primary">点击上传</el-button> -->
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件
            <p style="display:inline-block;color: rgb(154, 154, 154)">&nbsp;&nbsp;&nbsp;竖海报：COS-222*313，公网-412*600</p >
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </template>
      <template slot="posterH">
        <el-upload
          class="upload-demo-posterH"
          ref="upload"
          :action="postVideoUrl"
          name="videoImg"
          :on-preview="handlePreview"
          :http-request="uploadw"
          :on-success="uploadSuccessw"
          :on-remove="uploadRemovew"
          :on-exceed="handleExceed"
          :limit="1"
          :file-list="posterHList"
          list-type="picture-card">
          <i class="el-icon-plus"></i>
          <!-- <el-button size="small" type="primary">点击上传</el-button> -->
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件<p
            style="display:inline-block;color: rgb(154, 154, 154)">&nbsp;&nbsp;&nbsp;横海报：COS-272*203，公网-528*296</p >
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </template>
      <template slot="copyright">
        <el-input type="input" v-model='formValue.copyright' :disabled="true"></el-input>
        <el-button type="primary" style="margin-top:15px" @click="openCopyRight()">通过版权系统绑定</el-button>
        <el-button type="primary" style="margin-top:15px" @click="cancelCopyRight()">取消版权系统绑定</el-button>
      </template>
      <template slot="isCoverSonProCP">
        <el-radio-group v-model="formValue.isCoverSonProCP" >
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
      </template>
    </cs-form>
    <div class="footer">
      <el-button v-if="uploadPage=='true'" type="primary" style="width:80px" @click="completeHandle">完 成</el-button>
      <el-button v-else type="primary" style="width:80px" @click="searchHandle">提 交</el-button>
    </div>
    <CopyRightManage ref="copyRightManage" @boundSuccess="boundSuccess"/>
  </div>
</template>
<script>
import { uploadWImg, checkImg } from '@/resource/api/index'
import CopyRightManage from '@/views/common/dialog/copyRightManage.vue'

export default {
  name: 'ProgramCatalog',
  components: {
    CopyRightManage
  },
  props: ['formValue', 'categoryList', 'searchData', 'rules', 'sndCategory', 'keywords_tags', 'uploadPage', 'sndOptions'],
  data () {
    return {
      formLabelWidth: '100px',
      searchFormCol: 3,
      inputVisible: false, // 关键字 input
      inputValue: '', // 关键字 inputVal
      catalogData: null, // 动态表单
      dialogImageUrl: '',
      dialogVisible: false,
      posterList: [], // 竖海报上传的列表
      posterHList: [] // 横海报上传的列表
    }
  },
  computed: {
    postVideoUrl: function () {
      return process.env.VUE_APP_BASE_API_MGR + '/videoImgPaths/upload'
    }
  },
  methods: {
    formChange (params) {
      this.$emit('form-change', params)
    },
    handleClose (tag) {
      this.keywords_tags.splice(this.keywords_tags.indexOf(tag), 1)
      const keywords = this.keywords_tags.join(',')
      this.formValue.keywords = keywords.replace(/,/g, ' ')
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
      if (this.sndOptions.length > 50) {
        this.$message({
          message: '标签数量不可大于50个',
          type: 'error'
        })
      } else {
        this.$emit('keywordsChange', this.sndOptions)
      }
    },
    handleInputConfirm () {
      const inputValue = this.inputValue.replace(/\s+/g, '')
      if (this.keywords_tags.indexOf(inputValue) > -1) {
        this.inputValue = ''
        this.$message({
          message: '重复内容已自动剔除',
          type: 'error'
        })
        return
      }
      if (inputValue.length > 30) {
        this.$message({
          message: '单个标签不可大于30个字符',
          type: 'error'
        })
      } else if (this.keywords_tags.length > 49) {
        this.$message({
          message: '标签数量不可大于50个',
          type: 'error'
        })
      } else if (inputValue) {
        this.keywords_tags.push(inputValue)
        const keywords = this.keywords_tags.join(',')
        this.formValue.keywords = keywords.replace(/,/g, ' ')
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    posterShow () {
      this.posterList = [{
        url: this.formValue.poster,
        name: 'poster',
        id: this.formValue.poster
      }]
      this.hidePoster()
    },
    posterHShow () {
      this.posterHList = [{
        url: this.formValue.posterH,
        name: 'posterH',
        id: this.formValue.posterH
      }]
      this.hidePosterH()
    },
    sndChange (val) {
      this.$emit('sndChange', val)
    },
    openCopyRight () {
      this.$nextTick(() => {
        this.$refs.copyRightManage.open()
      })
    },
    cancelCopyRight () {
      this.$emit('cancelCopyRight')
    },
    boundSuccess (data) {
      this.$emit('boundChange', data)
    },
    searchHandle () {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          this.$emit('searchHandle')
        }
      })
    },
    completeHandle () {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          this.$emit('completeHandle')
        }
      })
    },
    // 文件上传相关
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //  竖海报
    async upload (params) {
      const that = this
      await that.checkFile(params.file, 0, params)
    },
    // 横海报
    async uploadw (params) {
      const that = this
      await that.checkFile(params.file, 1, params)
    },
    // 文件上传前对文件的验证
    async checkFile (file, type, params) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGt5M = file.size / 1024 / 1024 > 5
      if (!isJPG && !isPNG) {
        if (type == 1) {
          this.posterHList = []
        } else {
          this.posterList = []
        }
        this.$message.error('上传PNG/JPG 格式!')
        return false
      }
      if (isGt5M) {
        if (type == 1) {
          this.posterHList = []
        } else {
          this.posterList = []
        }
        this.$message.error('上传图片大小不能超过5M!')
        return false
      }
      var formData = new FormData()
      formData.append('imgFile', file)
      var that = this
      await checkImg(formData, type).then((res) => {
        if (res.code == 0) {
          that.$message({
            message: res.msg,
            type: 'error'
          })
          if (type == 1) {
            this.posterHList = []
          } else {
            this.posterList = []
          }
          return false
        } else if (res.code == 1) {
          const formData = new FormData()
          formData.append('videoImg', params.file)
          formData.append('username', that.$store.state.router.createBy)
          uploadWImg(formData).then((res) => {
            if (res.code == 1) {
              that.$message({
                message: '上传成功',
                type: 'success'
              })
              if (type == 0) {
                that.formValue.poster = res.result.imgPath
                this.hidePoster()
                this.$refs.groupForm.clearValidate('poster')
              } else {
                that.formValue.posterH = res.result.imgPath
                this.hidePosterH()
                this.$refs.groupForm.clearValidate('posterH')
              }
            } else {
              if (type == 1) {
                this.formValue.poster = null
              } else {
                this.formValue.poster = null
              }
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    uploadSuccess (response, file, fileList) {
      this.posterList = fileList
    },
    uploadSuccessw (response, file, fileList) {
      this.posterHList = fileList
    },
    uploadRemove (file, fileList) {
      this.posterList = []
      this.formValue.poster = ''
      const uploadBox = document.getElementsByClassName('el-upload--picture-card')
      uploadBox[0].style.display = 'inline-block'
    },
    uploadRemovew (file, fileList) {
      this.posterHList = []
      this.formValue.posterH = ''
      const uploadBox = document.getElementsByClassName('el-upload--picture-card')
      uploadBox[1].style.display = 'inline-block'
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    hidePoster () {
      const uploadBox = document.getElementsByClassName('el-upload--picture-card')
      uploadBox[0].style.display = 'none'
    },
    hidePosterH () {
      const uploadBox = document.getElementsByClassName('el-upload--picture-card')
      uploadBox[1].style.display = 'none'
    }
  }
}
</script>
<style lang="less">
.margin-t-box {
  margin-top: 20px;
  .el-tag {
    margin-right: 10px;
  }
}

.footer {
  text-align: center;
  margin: 50px 0 10px;
}
</style>
